module.exports = __webpack_public_path__ + "img/03.f8b92b62.png";